export const cols = [{
	prop: 'code',
	label: '优惠券编号',
	width: '200',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'createdate',
	label: '创建时间',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'name',
	label: '优惠券名称',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'type',
	label: '优惠券类型',
	width: '160',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'memo',
	label: '优惠内容',
	width: '260',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'forceflag',
	label: '获取方式',
	width: '160',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'countcoupon',
	label: '已发出',
	width: '160',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'usedcoupon',
	label: '已使用',
	width: '160',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'customername',
	label: '客户名称',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'ordercreatedate',
	label: '下单时间',
	width: '160',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'ordernumber',
	label: '订单号',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'usedmoney',
	label: '使用金额',
	width: '160',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'ordermoney',
	label: '订单金额',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'discountstate',
	label: '生效状态',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'usedflag',
	label: '是否使用',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}]
